import { ILocation } from "../../Api/Models/Customer";
import { IAddress } from "../../Api/Models/Order";

export const CheckAddress = (
    label: string,
    address: IAddress,
    location: ILocation | undefined,
    L: (key: string, fallback?: string) => string
): string | undefined => {
    if (!address.name) {
        return `${label} ${L('localization_address_name_required')}`;
    }
    if (!address.phoneNumber) {
        return `${label} ${L('localization_address_phone_required')}`;
    }
    if (location) {
        if (!location.address) {
            return `${label} ${L('localization_address_address_required')}`;
        }
        if (!location.city) {
            return `${label} ${L('localization_address_city_required')}`;
        }
        if (!location.state) {
            return `${label} ${L('localization_address_state_required')}`;
        }
    }
    else {
        if (!address.address1) {
            return `${label} ${L('localization_address_address1_required')}`;
        }
        if (!address.city) {
            return `${label} ${L('localization_address_city_required')}`;
        }
        if (!address.zipCode) {
            return `${label} ${L('localization_address_zip_required')}`;
        }
    }
    return undefined;
}

export const LocationToAddress = (location: ILocation): IAddress => {
    return {
        name: location?.name,
        phoneNumber: location?.phoneNumber,
        address1: location.address ?? '',
        address2: location.address2 ?? '',
        city: location.city ?? '',
        state: location.state ?? '',
        zipCode: location.postalCode ?? '',
        country: location.country ?? '',
    };
}

export const ConvertToAddress = (address: IAddress, location?: ILocation): IAddress => {
    if (!location) {
        return address;
    }
    return {
        name: address.name,
        phoneNumber: address.phoneNumber,
        address1: location.address ?? '',
        address2: location.address2 ?? '',
        city: location.city ?? '',
        state: location.state ?? '',
        zipCode: location.postalCode ?? '',
        country: location.country ?? '',
        locationId: location.id,
    }
}